export const removeAllSpace = (str: string) => {
  return str.replace(/\s+/g, "").trim();
};
